import Vue from 'vue'
import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-2'
export default ({ $config: { tawkToPropertyId, tawkToWidgetId } }) => {
    Vue.use(TawkMessengerVue, {
        propertyId: tawkToPropertyId,
        widgetId: tawkToWidgetId,
    })
}
